export default __webpack_public_path__ + "static/media/tqicon-9.1eb9f6fc.svg";